import {useParams} from 'react-router-dom';
import {useHashWizard} from '../../../../../common/components/wizards/useHashWizard';
import {useControllers} from '../../../../../../../common/helpers/react/hooks/useControllers';
import {asNumber} from '../../../../../../../common/helpers/converters/asNumber';
import GroupWizardStepTemplate from '../GroupWizardStepTemplate';
import {default as React, useState} from 'react';
import GroupWizardAgentsToolbar from './GroupWizardAgentsToolbar';
import GroupWizardAgentsTable from './GroupWizardAgentsTable';
import {GroupAgentsViews} from './GroupAgentsViews';
import {useOnce} from '../../../../../../../common/helpers/react/hooks/useOnce';
import {ensure} from '../../../../../../../common/types/guards/ensure';
import {isArrayOf} from '../../../../../../../common/types/guards/isArrayOf';
import {isString} from '../../../../../../../common/types/guards/isString';

export default function GroupWizardAgentsStepPresenter() {
    const {id} = useParams();

    const wh = useHashWizard();

    const groups = useControllers().groups;
    const agents = useControllers().agents;
    const groupId = asNumber(id);
    const group = groups.getGroupById$(groupId).useState() ?? undefined;

    const [groupAgentsView, setGroupAgentsView] = useState(GroupAgentsViews.MAIN);
    const [checkedRows, setCheckedRows] = useState<string[]>([]);

    const addFromAgents = agents.getToAddAssignees().useState();

    useOnce(() => {
        if (addFromAgents && addFromAgents.length && !wh.stepData?.add) {
            ensure(isArrayOf(isString), addFromAgents);
            wh.setStepData({
                add: [...addFromAgents]
            }).andWeAreDone();
        }
    });

    return (
        <GroupWizardStepTemplate wizardHelpers={wh} group={group}>
            <div>
                <GroupWizardAgentsToolbar
                    group={group}
                    groupAgentsView={groupAgentsView}
                    setGroupAgentsView={setGroupAgentsView}
                    checkedRows={checkedRows}
                    setCheckedRows={setCheckedRows}
                />
                <GroupWizardAgentsTable
                    group={group}
                    groupAgentsView={groupAgentsView}
                    checkedRows={checkedRows}
                    setCheckedRows={setCheckedRows}
                />
            </div>
        </GroupWizardStepTemplate>
    );
}